<template>
  <div class="native-form-item">
    <label v-if="label"><slot name="label">{{ label }}</slot></label>
    <slot />
    <span v-if="error" class="native-form-error">{{ error }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label?: string;
  prop?: string;
  rules?: unknown;
}>();

const error = "";
</script>
